export default "__VITE_ASSET__1Jh_liSz__"